import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { SignatureFieldsTable } from '~/components/settings/admin/signatureField/SignatureFieldsTable';

export const Route = createFileRoute(
  '/(main)/settings/admin/signature-fields/',
)({
  component: SignatureFieldsTable,
});

export const ADMIN_SIGNATURE_FIELDS = buildRouteExport({
  Route,
});
